export const defaultAnchorProps = {
  target: "_blank",
  rel: "noopener noreferrer",
};
